import { Typography } from "@mui/material";
import { WhiteCardContainer } from "./styles";

type Props = {
  onClick: () => void;
  primary: string;
  secondary?: string;
  disabled?: boolean;
  active?: boolean;
};

const WhiteCard = ({
  primary,
  secondary,
  onClick,
  disabled,
  active,
}: Props) => (
  <WhiteCardContainer
    onClick={onClick}
    disabled={disabled}
    active={active}
    disableRipple={disabled}
    disableTouchRipple={disabled}
  >
    <Typography sx={{ minWidth: "160px" }}>{primary}</Typography>
    <Typography color="textSecondary">{secondary}</Typography>
  </WhiteCardContainer>
);

export default WhiteCard;
